<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from '@/utils/ugm-swal'
import draggable from 'vuedraggable';

export default {
    components: { Layout, PageHeader, Multiselect, draggable },
    data() {
        const maxFileSizeMb = 80;
        const maxTotalSizeMb = 190;
        return {
            title: "Digitalizador",
            maxFileSizeMb,
            maxTotalSizeMb,
            maxFileSizeBytes: maxFileSizeMb * 1024 * 1024,
            maxTotalSizeBytes: maxTotalSizeMb * 1024 * 1024,
            items: [
                { text: "Digitalizar", href: "/" },
                { text: "Digitalizador", active: true }
            ],
            laborantes: [],
            eventos: [],
            eventoSeleccionado: null,
            nombreColegio: '',
            colegiosEventoOpciones: [],
            curso: '',
            cursoOpciones: ['1°', '2°', '3°', '4°', 'Egresado'],
            imagenesSeleccionadas: [],
            isLoading: false,
            localError: '',
            localSuccess: '',
        };
    },
    methods: {
        labelEvento(evento) { return `${evento.codigo} - ${evento.nombre_difusion}`; },
        esInteraccionSimulador(evento) {
            const nombre = String(
                (evento && (evento.nombre_difusion || evento.nombre || evento.title || '')) || ''
            )
                .trim()
                .toLowerCase();

            return nombre.startsWith('interaccion simulador') || nombre.startsWith('interacción simulador');
        },
        actualizarColegiosDesdeEvento(evento) {
            const opciones = [];

            if (evento && evento.colegios_json) {
                try {
                    const lista = typeof evento.colegios_json === 'string'
                        ? JSON.parse(evento.colegios_json)
                        : evento.colegios_json;

                    if (Array.isArray(lista)) {
                        lista.forEach((colegio) => {
                            const nombre = String(colegio?.nombre || '').trim();
                            if (nombre !== '') {
                                opciones.push(nombre);
                            }
                        });
                    }
                } catch (e) {}
            }

            if (!opciones.length) {
                const nombreLegacy = String(evento?.colegio || '').trim();
                if (nombreLegacy !== '') {
                    opciones.push(nombreLegacy);
                }
            }

            this.colegiosEventoOpciones = [...new Set(opciones)];

            if (!this.colegiosEventoOpciones.length) {
                this.nombreColegio = '';
                return;
            }

            if (!this.colegiosEventoOpciones.includes(this.nombreColegio)) {
                this.nombreColegio = this.colegiosEventoOpciones[0];
            }
        },
        totalArchivosSeleccionadosBytes() {
            return this.imagenesSeleccionadas.reduce((acc, actual) => acc + (actual?.file?.size || 0), 0);
        },
        agregarImagenes(event) {
            const nuevosArchivos = Array.from(event.target.files);
            nuevosArchivos.forEach((file) => {
                const tiposPermitidos = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'application/pdf'];
                if (!tiposPermitidos.includes(file.type)) {
                    Swal.fire({ icon: 'warning', title: 'Tipo no válido', text: `${file.name} no es imagen ni PDF.` });
                    return;
                }
                if (file.size > this.maxFileSizeBytes) {
                    Swal.fire({ icon: 'warning', title: 'Archivo muy grande', text: `${file.name} supera ${this.maxFileSizeMb} MB.` });
                    return;
                }
                const yaExiste = this.imagenesSeleccionadas.some(f => f.file.name === file.name && f.file.size === file.size);
                if (!yaExiste) {
                    if (this.totalArchivosSeleccionadosBytes() + file.size > this.maxTotalSizeBytes) {
                        Swal.fire({ icon: 'warning', title: 'Límite excedido', text: `La suma no puede superar ${this.maxTotalSizeMb} MB.` });
                        return;
                    }
                    if (file.type === 'application/pdf') {
                        this.imagenesSeleccionadas.push({ file, preview: '', isPdf: true });
                    } else {
                        const lector = new FileReader();
                        lector.onload = (e) => {
                            this.imagenesSeleccionadas.push({ file, preview: e.target.result, isPdf: false });
                        };
                        lector.readAsDataURL(file);
                    }
                }
            });
            this.$refs.inputImagenes.value = '';
        },
        eliminarImagen(index) {
            this.imagenesSeleccionadas.splice(index, 1);
            if (this.$refs.inputImagenes) this.$refs.inputImagenes.value = '';
        },
        limpiarFormulario() {
            this.eventoSeleccionado = null;
            this.nombreColegio = '';
            this.colegiosEventoOpciones = [];
            this.curso = '';
            this.imagenesSeleccionadas = [];
            this.localError = '';
            this.localSuccess = '';
            if (this.$refs.inputImagenes) this.$refs.inputImagenes.value = '';
        },
        handleDrop(event) {
            event.preventDefault();
            const files = event.dataTransfer.files;
            if (files.length) {
                const fakeEvent = { target: { files } };
                this.agregarImagenes(fakeEvent);
            }
        },
        handleUpload() {
            this.localError = '';
            this.localSuccess = '';
            if (!this.imagenesSeleccionadas.length) {
                this.localError = 'Debes seleccionar al menos un archivo en el Paso 1.'; return;
            }
            if (!this.eventoSeleccionado) {
                this.localError = 'Debes seleccionar un evento en el Paso 2.'; return;
            }
            this.isLoading = true;
            const formData = new FormData();
            this.imagenesSeleccionadas.forEach(imgObj => formData.append('imagenes[]', imgObj.file));
            formData.append('evento_id', this.eventoSeleccionado.id);
            if (this.nombreColegio) formData.append('nombre_colegio', this.nombreColegio);
            if (this.curso) formData.append('curso', this.curso);
            axios.post('/api/uploadImagesS3', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(response => {
                    const total = response.data.total_uploaded || 0;
                    const files = response.data.files || [];
                    const requestIds = files
                        .map(file => file.alegoria_request_id)
                        .filter(Boolean);

                    this.localSuccess = `${total} archivo(s) enviados a AlegoriaDocAPI. Redirigiendo al historial para seguimiento.`;

                    Swal.fire({
                        icon: 'success',
                        title: 'Archivo enviado a lectura',
                        html: `El documento quedo registrado y en proceso de OCR.<br><small>${requestIds.length ? 'Request ID: ' + requestIds.join('<br>') : 'Podras revisar el avance en el historial.'}</small>`,
                        timer: 2500,
                        showConfirmButton: false,
                    });

                    setTimeout(() => {
                        const query = encodeURIComponent(this.eventoSeleccionado?.nombre_difusion || this.eventoSeleccionado?.codigo || '');
                        window.location.href = `/web/digitalizar/historial${query ? `?q=${query}` : ''}`;
                    }, 1800);
                })
                .catch(error => {
                    const failures = error.response?.data?.errors;
                    this.localError = Array.isArray(failures) && failures.length
                        ? failures.map(item => `${item.file || 'Archivo'}: ${item.error || 'No se pudo procesar.'}`).join('\n')
                        : error.response?.data?.message || 'Hubo un problema al procesar los archivos.';
                    console.error(error);
                })
                .finally(() => { this.isLoading = false; });
        },
    },
    mounted() {
        axios.get('/api/get_eventos').then(r => {
            this.eventos = (r.data.eventos || []).filter(evento => !this.esInteraccionSimulador(evento));
        });
    },
    watch: {
        eventoSeleccionado: {
            immediate: false,
            handler(evento) {
                this.actualizarColegiosDesdeEvento(evento);
            }
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <!-- Header -->
        <div class="row">
            <div class="col-12">
                <div class="card mb-4" style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border: none;">
                    <div class="card-body d-flex align-items-center py-4">
                        <i class="bx bx-camera font-size-36 text-white mr-3"></i>
                        <div>
                            <h3 class="text-white mb-1 font-weight-bold">Digitalizador</h3>
                            <p class="text-white mb-0" style="opacity: 0.85;">Carga de archivos digitalizados para eventos</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Paso 1: Seleccionar documento -->
        <div class="row">
            <div class="col-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="d-flex align-items-center mb-4">
                            <div class="rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                                style="width:40px;height:40px;background:linear-gradient(135deg,#252C5F,#61B7E4);">
                                <span class="text-white font-weight-bold" style="font-size:16px;">1</span>
                            </div>
                            <div>
                                <h5 class="mb-0 font-weight-bold" style="color:#252C5F;">Seleccionar documento</h5>
                                <small class="text-muted">Formatos: JPG, PNG, GIF, PDF &middot; M&aacute;x. {{ maxFileSizeMb }} MB por archivo &middot; Total {{ maxTotalSizeMb }} MB</small>
                            </div>
                        </div>

                        <!-- Zona drag & drop -->
                        <div
                            class="drop-zone mb-3"
                            @click="$refs.inputImagenes.click()"
                            @dragover.prevent
                            @drop="handleDrop">
                            <i class="bx bx-cloud-upload drop-zone-icon"></i>
                            <p class="drop-zone-title">Arrastra los archivos aqu&iacute; o haz clic para seleccionar</p>
                            <p class="drop-zone-subtitle">JPG, PNG, GIF, PDF &middot; M&aacute;x. {{ maxFileSizeMb }} MB por archivo</p>
                        </div>
                        <input type="file" ref="inputImagenes" multiple accept="image/*,application/pdf" @change="agregarImagenes" style="display:none;" />

                        <!-- Previews arrastrables -->
                        <div v-if="imagenesSeleccionadas.length > 0">
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <span class="font-weight-medium" style="color:#252C5F;">
                                    <i class="bx bx-paperclip mr-1"></i>{{ imagenesSeleccionadas.length }} archivo(s) seleccionado(s)
                                </span>
                                <small class="text-muted">Arrastra para reordenar</small>
                            </div>
                            <draggable v-model="imagenesSeleccionadas" class="d-flex flex-wrap" :options="{ animation: 150 }">
                                <transition-group type="transition" name="fade" tag="div" class="d-flex flex-wrap">
                                    <div v-for="(imgObj, index) in imagenesSeleccionadas" :key="index * 890"
                                        class="position-relative m-2" style="width:110px;height:110px;cursor:grab;">
                                        <img v-if="!imgObj.isPdf" :src="imgObj.preview" alt="Imagen"
                                            class="img-thumbnail" style="width:100%;height:100%;object-fit:cover;border-color:#252C5F;" />
                                        <div v-else class="d-flex flex-column align-items-center justify-content-center img-thumbnail"
                                            style="width:100%;height:100%;background:#f0f4fa;border-color:#252C5F;">
                                            <i class="bx bxs-file-pdf" style="font-size:32px;color:#dc3545;"></i>
                                            <small class="text-muted text-center mt-1" style="font-size:10px;">
                                                {{ imgObj.file.name.length > 15 ? imgObj.file.name.substring(0, 12) + '...' : imgObj.file.name }}
                                            </small>
                                        </div>
                                        <b-button size="sm" variant="danger" class="position-absolute"
                                            style="top:-10px;right:-10px;border-radius:50%;width:24px;height:24px;padding:0;line-height:1;"
                                            @click.stop="eliminarImagen(index)">&#x2715;</b-button>
                                    </div>
                                </transition-group>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Paso 2: Asociar Evento -->
        <div class="row">
            <div class="col-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="d-flex align-items-center mb-4">
                            <div class="rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                                style="width:40px;height:40px;background:linear-gradient(135deg,#252C5F,#61B7E4);">
                                <span class="text-white font-weight-bold" style="font-size:16px;">2</span>
                            </div>
                            <div>
                                <h5 class="mb-0 font-weight-bold" style="color:#252C5F;">Asociar Evento</h5>
                                <small class="text-muted">Selecciona el evento al que pertenecen los archivos</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <multiselect
                                    v-model="eventoSeleccionado"
                                    :options="eventos"
                                    placeholder="Seleccionar evento"
                                    selectLabel="Enter para seleccionar"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Enter para remover"
                                    :custom-label="labelEvento">
                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                    <template v-slot:noResult><p>Sin coincidencias</p></template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Paso 3: Pre Formateo de campos -->
        <div class="row">
            <div class="col-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="d-flex align-items-center mb-4">
                            <div class="rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                                style="width:40px;height:40px;background:linear-gradient(135deg,#252C5F,#61B7E4);">
                                <span class="text-white font-weight-bold" style="font-size:16px;">3</span>
                            </div>
                            <div>
                                <h5 class="mb-0 font-weight-bold" style="color:#252C5F;">Pre Formateo de campos</h5>
                                <small class="text-muted">Informaci&oacute;n adicional del documento (opcional)</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="font-weight-medium mb-1">Nombre del Colegio</label>
                                <b-form-select
                                    v-if="colegiosEventoOpciones.length"
                                    v-model="nombreColegio"
                                    :options="[{ value: '', text: 'Seleccione el colegio' }, ...colegiosEventoOpciones.map(c => ({ value: c, text: c }))]"
                                />
                                <b-form-input
                                    v-else
                                    v-model="nombreColegio"
                                    placeholder="Ingrese el nombre del colegio"
                                />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="font-weight-medium mb-1">Curso</label>
                                <b-form-select v-model="curso" :options="[{ value: '', text: 'Seleccione el curso' }, ...cursoOpciones.map(c => ({ value: c, text: c }))]" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Paso 4: Enviar Documento -->
        <div class="row">
            <div class="col-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="d-flex align-items-center mb-4">
                            <div class="rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                                style="width:40px;height:40px;background:linear-gradient(135deg,#252C5F,#61B7E4);">
                                <span class="text-white font-weight-bold" style="font-size:16px;">4</span>
                            </div>
                            <div>
                                <h5 class="mb-0 font-weight-bold" style="color:#252C5F;">Enviar Documento</h5>
                                <small class="text-muted">Verifica los datos y env&iacute;a los archivos</small>
                            </div>
                        </div>

                        <b-button
                            variant="primary"
                            :disabled="isLoading"
                            @click="handleUpload"
                            class="px-5">
                            <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
                            <i class="bx bx-send mr-1" v-else></i>
                            Enviar Documento
                        </b-button>

                        <b-button variant="outline-secondary" class="ml-2" @click="limpiarFormulario" :disabled="isLoading">
                            <i class="bx bx-reset mr-1"></i> Limpiar
                        </b-button>

                        <b-alert variant="danger" :show="!!localError" class="mt-4" dismissible @dismissed="localError = ''">
                            <i class="bx bx-error-circle mr-1"></i> {{ localError }}
                        </b-alert>

                        <b-alert variant="success" :show="!!localSuccess" class="mt-4" dismissible @dismissed="localSuccess = ''">
                            <i class="bx bx-check-circle mr-1"></i> {{ localSuccess }}
                        </b-alert>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>

<style scoped>
.drop-zone {
    border: 2px dashed #61B7E4;
    border-radius: 10px;
    background: #f0f6fb;
    padding: 40px 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
}
.drop-zone:hover {
    border-color: #252C5F;
    background: #e6eef8;
}
.drop-zone-icon {
    font-size: 48px;
    color: #252C5F;
    display: block;
    margin-bottom: 8px;
}
.drop-zone-title {
    font-size: 15px;
    font-weight: 600;
    color: #252C5F;
    margin-bottom: 4px;
}
.drop-zone-subtitle {
    font-size: 12px;
    color: #8a92a6;
    margin-bottom: 0;
}
</style>
